(function () {
	'use strict';

	// angular.module('qbePortal').controller('ctpProgress', ctpProgress);

	// ctpProgress.$inject = ['$scope'];

	// function ctpProgress($scope) {
	// 	var vm = this;
	// 	vm.ctpCompleted = false;

	// 	$scope.$on('ctp-completed', function(event){
	// 		vm.ctpCompleted = true;
	// 	});	

	// }	

	angular.module('qbePortal').directive('qbCtpProgress', 
		function () {
			return {
				templateUrl: '../ngviews/directives/qbCtpProgress.html',
				//controller: ctpProgress,
				//controllerAs: 'vm',				
				restrict: 'E',
			     scope: {
			     		textDisplay:'=',
			     		ctpStepTotal:'=',
			     		ctpStepNum:'=',
			     		ctpCompleted:'='			              
			            },
			     transclude: true,							
				link: function (scope, element, attrs) {					
					scope.backToForm = function() {
						if(scope.ctpStepNum == 2){
							scope.$emit('show-form-entry');
						}
					}
				}
			};
		});

})();
